module.exports = __webpack_public_path__ + "static/media/add-users-icon.c6ad8c63.png";